import SpecIcons from '@/js/components/Shared/IconSelect/Icons/Specs'
import FrameIcons from '@/js/components/Shared/IconSelect/Icons/Frames'
import WeightIcons from '@/js/components/Shared/IconSelect/Icons/Weights'

export default {
  ...SpecIcons,
  ...FrameIcons,
  ...WeightIcons,
  AppendixIcon: () =>
    import(
      /* webpackChunkName: "AppendixIcon" */ '@/js/components/Shared/IconSelect/Icons/AppendixIcon.vue'
    ),
  BookmarksIcon: () =>
    import(
      /* webpackChunkName: "BookmarksIcon" */ '@/js/components/Shared/IconSelect/Icons/BookmarksIcon.vue'
    ),
  CalendarIcon: () =>
    import(
      /* webpackChunkName: "CalendarIcon" */ '@/js/components/Shared/IconSelect/Icons/CalendarIcon.vue'
    ),
  CheckmarkIcon: () =>
    import(
      /* webpackChunkName: "CheckmarkIcon" */ '@/js/components/Shared/IconSelect/Icons/CheckmarkIcon.vue'
    ),
  CloseIcon: () =>
    import(
      /* webpackChunkName: "CloseIcon" */ '@/js/components/Shared/IconSelect/Icons/CloseIcon.vue'
    ),
  ClipboardIcon: () =>
    import(
      /* webpackChunkName: "ClipboardIcon" */ '@/js/components/Shared/IconSelect/Icons/ClipboardIcon.vue'
    ),
  DashboardIcon: () =>
    import(
      /* webpackChunkName: "DashboardIcon" */ '@/js/components/Shared/IconSelect/Icons/DashboardIcon.vue'
    ),
  DownloadIcon: () =>
    import(
      /* webpackChunkName: "DownloadIcon" */ '@/js/components/Shared/IconSelect/Icons/DownloadIcon.vue'
    ),
  FallbackIcon: () =>
    import(
      /* webpackChunkName: "FallbackIcon" */ '@/js/components/Shared/IconSelect/Icons/FallbackIcon.vue'
    ),
  FavoritesIcon: () =>
    import(
      /* webpackChunkName: "FavoritesIcon" */ '@/js/components/Shared/IconSelect/Icons/FavoritesIcon.vue'
    ),
  FilterIcon: () =>
    import(
      /* webpackChunkName: "FilterIcon" */ '@/js/components/Shared/IconSelect/Icons/FilterIcon.vue'
    ),
  InfoIcon: () =>
    import(
      /* webpackChunkName: "InfoIcon" */ '@/js/components/Shared/IconSelect/Icons/InfoIcon.vue'
    ),
  ImagesIcon: () =>
    import(
      /* webpackChunkName: "ImagesIcon" */ '@/js/components/Shared/IconSelect/Icons/ImagesIcon.vue'
    ),
  LinkIcon: () =>
    import(
      /* webpackChunkName: "LinkIcon" */ '@/js/components/Shared/IconSelect/Icons/LinkIcon.vue'
    ),
  LightBulbIcon: () =>
    import(
      /* webpackChunkName: "LightBulbIcon" */ '@/js/components/Shared/IconSelect/Icons/LightBulbIcon.vue'
    ),
  RocketIcon: () =>
    import(
      /* webpackChunkName: "RocketIcon" */ '@/js/components/Shared/IconSelect/Icons/RocketIcon.vue'
    ),
  HeartIcon: () =>
    import(
      /* webpackChunkName: "HeartIcon" */ '@/js/components/Shared/IconSelect/Icons/HeartIcon.vue'
    ),
  LockIcon: () =>
    import(
      /* webpackChunkName: "LockIcon" */ '@/js/components/Shared/IconSelect/Icons/LockIcon.vue'
    ),
  MenuIcon: () =>
    import(
      /* webpackChunkName: "MenuIcon" */ '@/js/components/Shared/IconSelect/Icons/MenuIcon.vue'
    ),
  MessagesIcon: () =>
    import(
      /* webpackChunkName: "MessagesIcon" */ '@/js/components/Shared/IconSelect/Icons/MessagesIcon.vue'
    ),
  SaleIcon: () =>
    import(
      /* webpackChunkName: "SaleIcon" */ '@/js/components/Shared/IconSelect/Icons/SaleIcon.vue'
    ),
  ShortArrowDownIcon: () =>
    import(
      /* webpackChunkName: "ShortArrowDownIcon" */ '@/js/components/Shared/IconSelect/Icons/ShortArrowDownIcon.vue'
    ),
  ShippingIcon: () =>
    import(
      /* webpackChunkName: "ShippingIcon" */ '@/js/components/Shared/IconSelect/Icons/ShippingIcon.vue'
    ),
  StoreIcon: () =>
    import(
      /* webpackChunkName: "StoreIcon" */ '@/js/components/Shared/IconSelect/Icons/StoreIcon.vue'
    ),
  SparePartsTileIcon: () =>
    import(
      /* webpackChunkName: "SparePartsTileIcon" */ '@/js/components/Shared/IconSelect/Icons/SparePartsTileIcon.vue'
    ),
  SparePartsIcon: () =>
    import(
      /* webpackChunkName: "SparePartsIcon" */ '@/js/components/Shared/IconSelect/Icons/SparePartsIcon.vue'
    ),
  ServiceIcon: () =>
    import(
      /* webpackChunkName: "SparePartsIcon" */ '@/js/components/Shared/IconSelect/Icons/SparePartsIcon.vue'
    ),
  ArchiveIcon: () =>
    import(
      /* webpackChunkName: "SparePartsIcon" */ '@/js/components/Shared/IconSelect/Icons/SparePartsIcon.vue'
    ),
  BikeIcon: () =>
    import(
      /* webpackChunkName: "BikeIcon" */ '@/js/components/Shared/IconSelect/Icons/BikeIcon.vue'
    ),
  BikesIcon: () =>
    import(
      /* webpackChunkName: "BikeIcon" */ '@/js/components/Shared/IconSelect/Icons/BikeIcon.vue'
    ),
  CurrentIcon: () =>
    import(
      /* webpackChunkName: "BikeIcon" */ '@/js/components/Shared/IconSelect/Icons/BikeIcon.vue'
    ),
  OutletIcon: () =>
    import(
      /* webpackChunkName: "OutletIcon" */ '@/js/components/Shared/IconSelect/Icons/OutletIcon.vue'
    ),
  PosIcon: () =>
    import(/* webpackChunkName: "PosIcon" */ '@/js/components/Shared/IconSelect/Icons/PosIcon.vue'),
  AccessoriesIcon: () =>
    import(
      /* webpackChunkName: "AccessoriesIcon" */ '@/js/components/Shared/IconSelect/Icons/AccessoriesIcon.vue'
    ),
  OpenitemsIcon: () =>
    import(
      /* webpackChunkName: "OpenitemsIcon" */ '@/js/components/Shared/IconSelect/Icons/OpenitemsIcon.vue'
    ),
  OpenitemsTileIcon: () =>
    import(
      /* webpackChunkName: "OpenitemsTileIcon" */ '@/js/components/Shared/IconSelect/Icons/OpenitemsTileIcon.vue'
    ),
  ClickandcollectIcon: () =>
    import(
      /* webpackChunkName: "ClickAndCollectIcon" */ '@/js/components/Shared/IconSelect/Icons/ClickAndCollectIcon.vue'
    ),
  ClickandcollectTileIcon: () =>
    import(
      /* webpackChunkName: "ClickAndCollectTileIcon" */ '@/js/components/Shared/IconSelect/Icons/ClickAndCollectTileIcon.vue'
    ),
  CreditlimitIcon: () =>
    import(
      /* webpackChunkName: "CreditlimitIcon" */ '@/js/components/Shared/IconSelect/Icons/CreditlimitIcon.vue'
    ),
  CreditlimitTileIcon: () =>
    import(
      /* webpackChunkName: "CreditlimitTileIcon" */ '@/js/components/Shared/IconSelect/Icons/CreditlimitTileIcon.vue'
    ),
  TimerIcon: () =>
    import(
      /* webpackChunkName: "TimerIcon" */ '@/js/components/Shared/IconSelect/Icons/TimerIcon.vue'
    ),
  ToolsIcon: () =>
    import(
      /* webpackChunkName: "ToolsIcon" */ '@/js/components/Shared/IconSelect/Icons/ToolsIcon.vue'
    ),
  AccountIcon: () =>
    import(
      /* webpackChunkName: "AccountIcon" */ '@/js/components/Shared/IconSelect/Icons/AccountIcon.vue'
    ),
  BasketmobileIcon: () =>
    import(
      /* webpackChunkName: "BasketMobileIcon" */ '@/js/components/Shared/IconSelect/Icons/BasketMobileIcon.vue'
    ),
  BasketIcon: () =>
    import(
      /* webpackChunkName: "BasketIcon" */ '@/js/components/Shared/IconSelect/Icons/BasketIcon.vue'
    ),
  BasketListingIcon: () =>
    import(
      /* webpackChunkName: "BasketListingIcon" */ '@/js/components/Shared/IconSelect/Icons/BasketListingIcon.vue'
    ),
  WarningIcon: () =>
    import(
      /* webpackChunkName: "WarningIcon" */ '@/js/components/Shared/IconSelect/Icons/WarningIcon.vue'
    ),
  WarningTriangleIcon: () =>
    import(
      /* webpackChunkName: "WarningTriangleIcon" */ '@/js/components/Shared/IconSelect/Icons/WarningTriangleIcon.vue'
    ),
  TrashIcon: () =>
    import(
      /* webpackChunkName: "TrashIcon" */ '@/js/components/Shared/IconSelect/Icons/TrashIcon.vue'
    ),

  AddToBasketIcon: () =>
    import(
      /* webpackChunkName: "AddToBasketIcon" */ '@/js/components/Shared/IconSelect/Icons/AddToBasketIcon.vue'
    ),
  SearchIcon: () =>
    import(
      /* webpackChunkName: "SearchIcon" */ '@/js/components/Shared/IconSelect/Icons/SearchIcon.vue'
    ),
  // !!TODO: Update Icon if final version is ready
  ColorIcon: () =>
    import(
      /* webpackChunkName: "ColorIcon" */ '@/js/components/Shared/IconSelect/Icons/ColorIcon.vue'
    ),
  // !!TODO: Update Icon if final version is ready
  FrameSizeIcon: () =>
    import(
      /* webpackChunkName: "FrameSizeIcon" */ '@/js/components/Shared/IconSelect/Icons/FrameSizeIcon.vue'
    ),
  ExportIcon: () =>
    import(
      /* webpackChunkName: "ExportIcon" */ '@/js/components/Shared/IconSelect/Icons/ExportIcon.vue'
    ),
  BurgerMenuIcon: () =>
    import(
      /* webpackChunkName: "BurgerMenuIcon" */ '@/js/components/Shared/IconSelect/Icons/BurgerMenuIcon.vue'
    ),
  AddIcon: () =>
    import(/* webpackChunkName: "AddIcon" */ '@/js/components/Shared/IconSelect/Icons/AddIcon.vue'),
  SubstractIcon: () =>
    import(
      /* webpackChunkName: "SubstractIcon" */ '@/js/components/Shared/IconSelect/Icons/SubstractIcon.vue'
    ),
  AddCircleIcon: () =>
    import(
      /* webpackChunkName: "AddCircleIcon" */ '@/js/components/Shared/IconSelect/Icons/AddCircleIcon.vue'
    ),
  SubstractCircleIcon: () =>
    import(
      /* webpackChunkName: "SubstractCircleIcon" */ '@/js/components/Shared/IconSelect/Icons/SubstractCircleIcon.vue'
    ),
  GridIcon: () =>
    import(
      /* webpackChunkName: "ListingTilesIcon" */ '@/js/components/Shared/IconSelect/Icons/ListingTilesIcon.vue'
    ),
  ListIcon: () =>
    import(
      /* webpackChunkName: "ListingRowsIcon" */ '@/js/components/Shared/IconSelect/Icons/ListingRowsIcon.vue'
    ),
  MontageVideosIcon: () =>
    import(
      /* webpackChunkName: "MontageVideosIcon" */ '@/js/components/Shared/IconSelect/Icons/MontageVideosIcon.vue'
    ),
  DocumentsIcon: () =>
    import(
      /* webpackChunkName: "DocumentsIcon" */ '@/js/components/Shared/IconSelect/Icons/DocumentsIcon.vue'
    ),
  InboxIcon: () =>
    import(
      /* webpackChunkName: "InboxIcon" */ '@/js/components/Shared/IconSelect/Icons/InboxIcon.vue'
    ),
  TicketsMailIcon: () =>
    import(
      /* webpackChunkName: "TicketsMailIcon" */ '@/js/components/Shared/IconSelect/Icons/TicketsMailIcon.vue'
    ),
  InfosMailIcon: () =>
    import(
      /* webpackChunkName: "InfosMailIcon" */ '@/js/components/Shared/IconSelect/Icons/InfosMailIcon.vue'
    ),
  MarketingMailIcon: () =>
    import(
      /* webpackChunkName: "MarketingMailIcon" */ '@/js/components/Shared/IconSelect/Icons/MarketingMailIcon.vue'
    ),
  TicketsIcon: () =>
    import(
      /* webpackChunkName: "TicketsIcon" */ '@/js/components/Shared/IconSelect/Icons/TicketsIcon.vue'
    ),
  MarketingIcon: () =>
    import(
      /* webpackChunkName: "MarketingIcon" */ '@/js/components/Shared/IconSelect/Icons/MarketingIcon.vue'
    ),
  SaveIcon: () =>
    import(
      /* webpackChunkName: "SaveIcon" */ '@/js/components/Shared/IconSelect/Icons/SaveIcon.vue'
    ),
  CopyIcon: () =>
    import(
      /* webpackChunkName: "CopyIcon" */ '@/js/components/Shared/IconSelect/Icons/CopyIcon.vue'
    ),
  BacklinkIcon: () =>
    import(
      /* webpackChunkName: "BacklinkIcon_" */ '@/js/components/Shared/IconSelect/Icons/BacklinkIcon.vue'
    ),
  StarIcon: () =>
    import(
      /* webpackChunkName: "StarIcon" */ '@/js/components/Shared/IconSelect/Icons/StarIcon.vue'
    ),
  UserIcon: () =>
    import(
      /* webpackChunkName: "UserIcon" */ '@/js/components/Shared/IconSelect/Icons/UserIcon.vue'
    ),
  MessagesBadgeIcon: () =>
    import(
      /* webpackChunkName: "MessagesBadgeIcon" */ '@/js/components/Shared/IconSelect/Icons/MessagesBadgeIcon.vue'
    ),
  HeartFilledIcon: () =>
    import(
      /* webpackChunkName: "HeartFilledIcon" */ '@/js/components/Shared/IconSelect/Icons/HeartFilledIcon.vue'
    ),
  ShareIcon: () =>
    import(
      /* webpackChunkName: "ShareIcon" */ '@/js/components/Shared/IconSelect/Icons/ShareIcon.vue'
    ),
  SendMailIcon: () =>
    import(
      /* webpackChunkName: "SendMailIcon" */ '@/js/components/Shared/IconSelect/Icons/SendMailIcon.vue'
    ),
  ClipIcon: () =>
    import(
      /* webpackChunkName: "ClipIcon" */ '@/js/components/Shared/IconSelect/Icons/ClipIcon.vue'
    ),
  FastCheckoutIcon: () =>
    import(
      /* webpackChunkName: "FastCheckoutIcon" */ '@/js/components/Shared/IconSelect/Icons/FastCheckoutIcon.vue'
    ),
  ContractCheckIcon: () =>
    import(
      /* webpackChunkName: "ContractCheckIcon" */ '@/js/components/Shared/IconSelect/Icons/ContractCheckIcon.vue'
    ),
  ContractCheckTileIcon: () =>
    import(
      /* webpackChunkName: "ContractCheckTileIcon" */ '@/js/components/Shared/IconSelect/Icons/ContractCheckTileIcon.vue'
    ),
  EditIcon: () =>
    import(
      /* webpackChunkName: "EditIcon" */ '@/js/components/Shared/IconSelect/Icons/EditIcon.vue'
    ),
  CopyDataIcon: () =>
    import(
      /* webpackChunkName: "CopyDataIcon" */ '@/js/components/Shared/IconSelect/Icons/CopyDataIcon.vue'
    ),
  QuickBuyIcon: () =>
    import(
      /* webpackChunkName: "QuickBuyIcon" */ '@/js/components/Shared/IconSelect/Icons/QuickBuyIcon.vue'
    ),
  TruckIcon: () =>
    import(
      /* webpackChunkName: "TruckIcon" */ '@/js/components/Shared/IconSelect/Icons/TruckIcon.vue'
    ),
  TruckTileIcon: () =>
    import(
      /* webpackChunkName: "TruckTileIcon" */ '@/js/components/Shared/IconSelect/Icons/TruckTileIcon.vue'
    ),
  ChevronUpIcon: () =>
    import(
      /* webpackChunkName: "ChevronUpIcon" */ '@/js/components/Shared/IconSelect/Icons/ChevronUpIcon.vue'
    ),
  BellIcon: () =>
    import(
      /* webpackChunkName: "BellIcon" */ '@/js/components/Shared/IconSelect/Icons/BellIcon.vue'
    ),
  BellCheckIcon: () =>
    import(
      /* webpackChunkName: "BellCheckIcon" */ '@/js/components/Shared/IconSelect/Icons/BellCheckIcon.vue'
    ),
  CompareIcon: () =>
    import(
      /* webpackChunkName: "CompareIcon" */ '@/js/components/Shared/IconSelect/Icons/CompareIcon.vue'
    ),
  InvoiceListIcon: () =>
    import(
      /* webpackChunkName: "InvoiceListIcon" */ '@/js/components/Shared/IconSelect/Icons/InvoiceListIcon.vue'
    ),
  InvoiceListTileIcon: () =>
    import(
      /* webpackChunkName: "InvoiceListTileIcon" */ '@/js/components/Shared/IconSelect/Icons/InvoiceListTileIcon.vue'
    ),
  BackorderListIcon: () =>
    import(
      /* webpackChunkName: "BackorderListIcon" */ '@/js/components/Shared/IconSelect/Icons/BackorderListIcon.vue'
    ),
  BackorderListTileIcon: () =>
    import(
      /* webpackChunkName: "BackorderListTileIcon" */ '@/js/components/Shared/IconSelect/Icons/BackorderListTileIcon.vue'
    ),
  VacationListIcon: () =>
    import(
      /* webpackChunkName: "VacationListIcon" */ '@/js/components/Shared/IconSelect/Icons/VacationListIcon.vue'
    ),
  VacationListTileIcon: () =>
    import(
      /* webpackChunkName: "VacationListTileIcon" */ '@/js/components/Shared/IconSelect/Icons/VacationListTileIcon.vue'
    ),
  PrintIcon: () =>
    import(
      /* webpackChunkName: "PrintIcon" */ '@/js/components/Shared/IconSelect/Icons/PrintIcon.vue'
    ),
  EbikeEngineModelIcon: () =>
    import(
      /* webpackChunkName: "EbikeEngineModelIcon" */ '@/js/components/Shared/IconSelect/Icons/Specs/Ebike/EbikeEngineModelIcon.vue'
    ),
  SerialNumberSearchIcon: () =>
    import(
      /* webpackChunkName: "SerialNumberSearchIcon" */ '@/js/components/Shared/IconSelect/Icons/SerialNumberSearchIcon.vue'
    ),
  RefreshIcon: () =>
    import(
      /* webpackChunkName: "RefreshIcon" */ '@/js/components/Shared/IconSelect/Icons/RefreshIcon.vue'
    ),
  OkayCircleIcon: () =>
    import(
      /* webpackChunkName: "OkayCircleIcon" */ '@/js/components/Shared/IconSelect/Icons/OkayCircleIcon.vue'
    ),
  ReviewsIcon: () =>
    import(
      /* webpackChunkName: "ReviewsIcon" */ '@/js/components/Shared/IconSelect/Icons/ReviewsIcon.vue'
    ),
  AlertRhombusOutlineIcon: () =>
    import(
      /* webpackChunkName: "AlertRhombusOutlineIcon" */ '@/js/components/Shared/IconSelect/Icons/AlertRhombusOutlineIcon.vue'
    ),
  UserManagementIcon: () =>
    import(
      /* webpackChunkName: "UserManagementIcon" */ '@/js/components/Shared/IconSelect/Icons/UserManagementIcon.vue'
    ),
  UserManagementTileIcon: () =>
    import(
      /* webpackChunkName: "UserManagementTileIcon" */ '@/js/components/Shared/IconSelect/Icons/UserManagementTileIcon.vue'
    ),
  OrderTrackingIcon: () =>
    import(
      /* webpackChunkName: "OrderTrackingIcon" */ '@/js/components/Shared/IconSelect/Icons/OrderTrackingIcon.vue'
    ),
  MyDataIcon: () =>
    import(
      /* webpackChunkName: "MyDataIcon" */ '@/js/components/Shared/IconSelect/Icons/MyDataIcon.vue'
    ),
  MyDataTileIcon: () =>
    import(
      /* webpackChunkName: "MyDataTileIcon" */ '@/js/components/Shared/IconSelect/Icons/MyDataTileIcon.vue'
    ),
  CustomerAddressesIcon: () =>
    import(
      /* webpackChunkName: "CustomerAddressesIcon" */ '@/js/components/Shared/IconSelect/Icons/CustomerAddressesIcon.vue'
    ),
  CustomerAddressesTileIcon: () =>
    import(
      /* webpackChunkName: "CustomerAddressesTileIcon" */ '@/js/components/Shared/IconSelect/Icons/CustomerAddressesTileIcon.vue'
    ),
  BadgeNewIcon: () =>
    import(
      /* webpackChunkName: "BadgeNewIcon" */ '@/js/components/Shared/IconSelect/Icons/BadgeNewIcon.vue'
    ),
  OrderHistoryIcon: () =>
    import(
      /* webpackChunkName: "OrderHistoryIcon" */ '@/js/components/Shared/IconSelect/Icons/OrderHistoryIcon.vue'
    ),
  OrderHistoryTileIcon: () =>
    import(
      /* webpackChunkName: "OrderHistoryTileIcon" */ '@/js/components/Shared/IconSelect/Icons/OrderHistoryTileIcon.vue'
    ),
  StoreCheckIcon: () =>
    import(
      /* webpackChunkName: "StoreCheckIcon" */ '@/js/components/Shared/IconSelect/Icons/StoreCheckIcon.vue'
    ),
  StoreCheckTileIcon: () =>
    import(
      /* webpackChunkName: "StoreCheckTileIcon" */ '@/js/components/Shared/IconSelect/Icons/StoreCheckTileIcon.vue'
    ),
  SupportaccessIcon: () =>
    import(
      /* webpackChunkName: "SupportaccessIcon" */ '@/js/components/Shared/IconSelect/Icons/SupportaccessIcon.vue'
    ),
  SupportaccessTileIcon: () =>
    import(
      /* webpackChunkName: "SupportaccessTileIcon" */ '@/js/components/Shared/IconSelect/Icons/SupportaccessTileIcon.vue'
    ),
  ComplaintIcon: () =>
    import(
      /* webpackChunkName: "ComplaintIcon" */ '@/js/components/Shared/IconSelect/Icons/ComplaintIcon.vue'
    ),
  WorktimeCompensationIcon: () =>
    import(
      /* webpackChunkName: "WorktimeCompensationIcon" */ '@/js/components/Shared/IconSelect/Icons/WorktimeCompensationIcon.vue'
    ),
  SendReturnsIcon: () =>
    import(
      /* webpackChunkName: "SendReturnsIcon" */ '@/js/components/Shared/IconSelect/Icons/SendReturnsIcon.vue'
    ),
  SendReturnsTileIcon: () =>
    import(
      /* webpackChunkName: "SendReturnsTileIcon" */ '@/js/components/Shared/IconSelect/Icons/SendReturnsTileIcon.vue'
    ),
  RMAListIcon: () =>
    import(
      /* webpackChunkName: "RMAListIcon" */ '@/js/components/Shared/IconSelect/Icons/RMAListIcon.vue'
    ),
  RMAListTileIcon: () =>
    import(
      /* webpackChunkName: "RMAListTileIcon" */ '@/js/components/Shared/IconSelect/Icons/RMAListTileIcon.vue'
    ),
  ReturnRequestIcon: () =>
    import(
      /* webpackChunkName: "ReturnRequestIcon" */ '@/js/components/Shared/IconSelect/Icons/ReturnRequestIcon.vue'
    ),
  ReturnRequestTileIcon: () =>
    import(
      /* webpackChunkName: "ReturnRequestTileIcon" */ '@/js/components/Shared/IconSelect/Icons/ReturnRequestTileIcon.vue'
    ),
  EngineRmaIcon: () =>
    import(
      /* webpackChunkName: "EngineRmaIcon" */ '@/js/components/Shared/IconSelect/Icons/EngineRmaIcon.vue'
    ),
  EngineRmaTileIcon: () =>
    import(
      /* webpackChunkName: "EngineRmaTileIcon" */ '@/js/components/Shared/IconSelect/Icons/EngineRmaTileIcon.vue'
    ),
  EngineRmaListIcon: () =>
    import(
      /* webpackChunkName: "EngineRmaListIcon" */ '@/js/components/Shared/IconSelect/Icons/EngineRmaListIcon.vue'
    ),
  EngineRmaListTileIcon: () =>
    import(
      /* webpackChunkName: "EngineRmaListTileIcon" */ '@/js/components/Shared/IconSelect/Icons/EngineRmaListTileIcon.vue'
    ),
  ComponentRmaIcon: () =>
    import(
      /* webpackChunkName: "ComponentRmaIcon" */ '@/js/components/Shared/IconSelect/Icons/ComponentRmaIcon.vue'
    ),
  ComponentRmaTileIcon: () =>
    import(
      /* webpackChunkName: "ComponentRmaTileIcon" */ '@/js/components/Shared/IconSelect/Icons/ComponentRmaTileIcon.vue'
    ),
  BatteryAndChargerRmaIcon: () =>
    import(
      /* webpackChunkName: "BatteryAndChargerRmaIcon" */ '@/js/components/Shared/IconSelect/Icons/BatteryAndChargerRmaIcon.vue'
    ),
  BatteryAndChargerRmaTileIcon: () =>
    import(
      /* webpackChunkName: "BatteryAndChargerRmaTileIcon" */ '@/js/components/Shared/IconSelect/Icons/BatteryAndChargerRmaTileIcon.vue'
    ),
  CountryFlagGermanyIcon: () =>
    import(
      /* webpackChunkName: "CountryFlagGermanyIcon" */ '@/js/components/Shared/IconSelect/Icons/CountryFlagGermanyIcon.vue'
    ),
  CountryFlagUnitedKingdomIcon: () =>
    import(
      /* webpackChunkName: "CountryFlagUnitedKingdomIcon" */ '@/js/components/Shared/IconSelect/Icons/CountryFlagUnitedKingdomIcon.vue'
    ),
  CountryFlagFranceIcon: () =>
    import(
      /* webpackChunkName: "CountryFlagFranceIcon" */ '@/js/components/Shared/IconSelect/Icons/CountryFlagFranceIcon.vue'
    ),
  CountryFlagSpainIcon: () =>
    import(
      /* webpackChunkName: "CountryFlagSpainIcon" */ '@/js/components/Shared/IconSelect/Icons/CountryFlagSpainIcon.vue'
    ),
  CountryFlagNetherlandsIcon: () =>
    import(
      /* webpackChunkName: "CountryFlagNetherlandsIcon" */ '@/js/components/Shared/IconSelect/Icons/CountryFlagNetherlandsIcon.vue'
    ),
  CountryFlagCzechIcon: () =>
    import(
      /* webpackChunkName: "CountryFlagCzechIcon" */ '@/js/components/Shared/IconSelect/Icons/CountryFlagCzechIcon.vue'
    ),
  CountryFlagPolandIcon: () =>
    import(
      /* webpackChunkName: "CountryFlagPolandIcon" */ '@/js/components/Shared/IconSelect/Icons/CountryFlagPolandIcon.vue'
    ),
  MessageCenterTicketsIcon: () =>
    import(
      /* webpackChunkName: "MessageCenterTicketsIcon" */ '@/js/components/Shared/IconSelect/Icons/MessageCenterTicketsIcon.vue'
    ),
  MessageCenterInfosIcon: () =>
    import(
      /* webpackChunkName: "MessageCenterInfosIcon" */ '@/js/components/Shared/IconSelect/Icons/MessageCenterInfosIcon.vue'
    ),
  MessageCenterNewsIcon: () =>
    import(
      /* webpackChunkName: "MessageCenterNewsIcon" */ '@/js/components/Shared/IconSelect/Icons/MessageCenterNewsIcon.vue'
    ),
  EditPermissionIcon: () =>
    import(
      /* webpackChunkName: "MessageCenterNewsIcon" */ '@/js/components/Shared/IconSelect/Icons/EditPermissionIcon.vue'
    ),
  Degree360Icon: () =>
    import(/* webpackChunkName: "360Icon" */ '@/js/components/Shared/IconSelect/Icons/360Icon.vue'),
  PriceDownloadIcon: () =>
    import(
      /* webpackChunkName: "PriceDownloadIcon" */ '@/js/components/Shared/IconSelect/Icons/PriceDownloadIcon.vue'
    ),
  SpecDownloadIcon: () =>
    import(
      /* webpackChunkName: "SpecDownloadIcon" */ '@/js/components/Shared/IconSelect/Icons/SpecDownloadIcon.vue'
    ),
  HubSpotChatIcon: () =>
    import(
      /* webpackChunkName: "HubSpotChatIcon" */ '@/js/components/Shared/IconSelect/Icons/HubSpotChatIcon.vue'
    ),
  FlagIcon: () =>
    import(
      /* webpackChunkName: "FlagIcon" */ '@/js/components/Shared/IconSelect/Icons/FlagIcon.vue'
    ),
  BackIcon: () =>
    import(
      /* webpackChunkName: "BackIcon" */ '@/js/components/Shared/IconSelect/Icons/BackIcon.vue'
    ),
  ForthIcon: () =>
    import(
      /* webpackChunkName: "ForthIcon" */ '@/js/components/Shared/IconSelect/Icons/ForthIcon.vue'
    ),
  ExchangeIcon: () =>
    import(
      /* webpackChunkName: "ExchangeIcon" */ '@/js/components/Shared/IconSelect/Icons/ExchangeIcon.vue'
    ),
  TrackingSmallIcon: () =>
    import(
      /* webpackChunkName: "TrackingSmallIcon" */ '@/js/components/Shared/IconSelect/Icons/TrackingSmallIcon.vue'
    ),
  TrackingSmallPosIcon: () =>
    import(
      /* webpackChunkName: "TrackingSmallPosIcon" */ '@/js/components/Shared/IconSelect/Icons/TrackingSmallPosIcon.vue'
    ),
  TrackingSmallNegIcon: () =>
    import(
      /* webpackChunkName: "TrackingSmallNegIcon" */ '@/js/components/Shared/IconSelect/Icons/TrackingSmallNegIcon.vue'
    ),
  AzvgIcon: () =>
    import(
      /* webpackChunkName: "AzvgIcon" */ '@/js/components/Shared/IconSelect/Icons/AzvgIcon.vue'
    ),
  AzvgPosIcon: () =>
    import(
      /* webpackChunkName: "AzvgPosIcon" */ '@/js/components/Shared/IconSelect/Icons/AzvgPosIcon.vue'
    ),
  AzvgNegIcon: () =>
    import(
      /* webpackChunkName: "AzvgNegIcon" */ '@/js/components/Shared/IconSelect/Icons/AzvgNegIcon.vue'
    ),
  CreditIcon: () =>
    import(
      /* webpackChunkName: "CreditIcon" */ '@/js/components/Shared/IconSelect/Icons/CreditIcon.vue'
    ),

  ItemReturnShipmentsSmallNegIcon: () =>
    import(
      /* webpackChunkName: "ItemReturnShipmentsSmallNegIcon" */ '@/js/components/Shared/IconSelect/Icons/ItemReturnShipmentsSmallNegIcon.vue'
    ),

  ItemReturnShipmentsSmallIcon: () =>
    import(
      /* webpackChunkName: "ItemReturnShipmentsSmallNegIcon" */ '@/js/components/Shared/IconSelect/Icons/ItemReturnShipmentsSmallIcon.vue'
    ),
  ItemReturnShipmentsSmallPosIcon: () =>
    import(
      /* webpackChunkName: "ItemReturnShipmentsSmallPosIcon" */ '@/js/components/Shared/IconSelect/Icons/ItemReturnShipmentsSmallPosIcon.vue'
    ),
  CreditPosIcon: () =>
    import(
      /* webpackChunkName: "CreditPosIcon" */ '@/js/components/Shared/IconSelect/Icons/CreditPosIcon.vue'
    ),
  CreditNegIcon: () =>
    import(
      /* webpackChunkName: "CreditNegIcon" */ '@/js/components/Shared/IconSelect/Icons/CreditNegIcon.vue'
    ),
  DownloadArrowIcon: () =>
    import(
      /* webpackChunkName: "DownloadArrowIcon" */ '@/js/components/Shared/IconSelect/Icons/DownloadArrowIcon.vue'
    ),
}
